export default __webpack_public_path__ + "static/media/Matter-Regular.301b44e8.eot";